import { TWithdrawRequest } from "@/redux/feature/balaneWithdraw/balanceWithdrawTypes";
import { X } from "lucide-react";
import React, { useState } from "react";

const WithdrawRequestDetails = ({
  withdrawRequest,
  onApprove,
  onReject,
  onClose,
  loading,
}: {
  onClose: () => void;
  loading: boolean;
  onReject: () => void;
  onApprove: () => void;
  withdrawRequest: TWithdrawRequest;
}) => {
  return (
    <div className="p-4">
      <div className="flex flex-col gap-4">
        <div className="flex justify-between items-center">
          <h2 className="text-xl font-semibold">Withdraw Request Details</h2>
          <button onClick={onClose}>
            <X />
          </button>
        </div>

        <div>
          <p>
            {" "}
            <strong>Creator:</strong> {withdrawRequest.creator_id.fullName}
          </p>
          <p>
            <strong>Email:</strong> {withdrawRequest.creator_id.email}
          </p>
        </div>

        <div className="border-y py-3">
          <h4 className="text-xl font-medium pb-2">Bank Details</h4>
          <div>
            <strong>Account Holder Name:</strong>{" "}
            {withdrawRequest.paymentMethod.details.accountHolderName}
          </div>
          <div>
            <strong>Bank Name:</strong>{" "}
            {withdrawRequest.paymentMethod.details.bankName}
          </div>
          <div>
            <strong>Account Number:</strong>{" "}
            {withdrawRequest.paymentMethod.details.accountNumber}
          </div>
          {withdrawRequest.paymentMethod.details.branchName && (
            <div>
              <strong>Branch Name:</strong>{" "}
              {withdrawRequest.paymentMethod.details.branchName}
            </div>
          )}
          <div>
            <strong>Routing Code:</strong>{" "}
            {withdrawRequest.paymentMethod.details.routingCode}
          </div>
          <div>
            <strong>Country:</strong>{" "}
            {withdrawRequest.paymentMethod.details.country}
          </div>
          {withdrawRequest.paymentMethod.details.bankAddress && (
            <div>
              <strong>Bank Address:</strong>{" "}
              {withdrawRequest.paymentMethod.details.bankAddress}
            </div>
          )}
          {withdrawRequest.paymentMethod.details.contactNumber && (
            <div>
              <strong>Contact Number:</strong>{" "}
              {withdrawRequest.paymentMethod.details.contactNumber}
            </div>
          )}
        </div>
        <div className="text-lg font-semibold">
          <p>
            {" "}
            <strong>Amount:</strong> {withdrawRequest.currency}{" "}
            {withdrawRequest.amount}{" "}
          </p>
        </div>
        <div>
          <strong>Status:</strong>{" "}
          <span className="capitalize">{withdrawRequest.status}</span>
        </div>
        {withdrawRequest.note && (
          <div>
            <strong>Note:</strong> {withdrawRequest.note}
          </div>
        )}

     
      </div>
    </div>
  );
};

export default WithdrawRequestDetails;
